import { z } from "zod";
const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
function buildDateOnlyString(year, month, day) {
    return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}
export function isValidDateOnlyString(value) {
    const match = DATE_ONLY_PATTERN.exec(value);
    if (!match) {
        return false;
    }
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const parsed = new Date(year, month - 1, day);
    return (!Number.isNaN(parsed.getTime()) &&
        parsed.getFullYear() === year &&
        parsed.getMonth() === month - 1 &&
        parsed.getDate() === day);
}
export function parseDateOnlyString(value) {
    if (!isValidDateOnlyString(value)) {
        return null;
    }
    const [year, month, day] = value.split("-").map(Number);
    const parsed = new Date(year, month - 1, day);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
}
export function parseDateOnlyInput(value) {
    if (!value) {
        return null;
    }
    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
    }
    const trimmed = value.trim();
    if (!trimmed) {
        return null;
    }
    return parseDateOnlyString(trimmed);
}
export function formatDateOnlyString(value) {
    if (Number.isNaN(value.getTime())) {
        return null;
    }
    return buildDateOnlyString(value.getFullYear(), value.getMonth() + 1, value.getDate());
}
export function requireDateOnlyString(value) {
    const formatted = formatDateOnlyString(value);
    if (!formatted) {
        throw new Error("Invalid Date supplied to requireDateOnlyString");
    }
    return formatted;
}
export const dateOnlyStringSchema = z
    .string()
    .regex(DATE_ONLY_PATTERN, "Date must use YYYY-MM-DD format")
    .refine(isValidDateOnlyString, "Date must be a real calendar date")
    .transform((value) => value);
